import './Activity.css';

import React, { Component } from 'react';
import { Grid, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { TableContainer } from '../table';
import { ActionBar } from '../actionBar';

import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import ActivitySkillsContainer from '../activitySkills/ActivitySkillsContainer';

class Activity extends Component {
    render() {
        //comments added
        const { scene } = this.props;
        return (
            <div>
            <ActionBar />
            <Grid fluid>
                <Tabs selectedTabPanelClassName="selected" selectedTabClassName="selected">
                    <div className="tabs-container row">
                        <div className="container">
                            <div className="activity-name">
                                <h2 key='ab_activity-title-h2'>{scene}</h2>
                            </div>
                            <TabList className="activity-nav">
                                <Tab><i className="fas fa-play"></i>&nbsp; Activity</Tab>
                                <Tab><i className="fas fa-list-ol"></i>&nbsp; Datasets</Tab>
                                <Tab><i className="fas fa-list-alt"></i>&nbsp; Skill Details</Tab>
                                <Tab><i className="fas fa-file-archive"></i>&nbsp; Bundles</Tab>
                            </TabList>
                        </div>
                    </div>
                    <TabPanel>
                        <Col>
                            <TableContainer />
                        </Col>
                    </TabPanel>
                    <TabPanel>
                        <div className="tab-content">
                            Datasets info will be here.
                        </div>
                    </TabPanel>
                    <TabPanel>
                        <div className="tab-content">
                            <ActivitySkillsContainer scene={scene} />
                        </div>
                    </TabPanel>
                    <TabPanel>
                        <div className="tab-content">
                            Bundles info will be here.
                        </div>
                    </TabPanel>
                </Tabs>
            </Grid>
            </div>
        )
    }
}

Activity.propTypes = {
    scene: PropTypes.string.isRequired
};

const mapStateToProps = state => ({
    scene: state.scene.current
});

export default connect(
    mapStateToProps
)(Activity);



// WEBPACK FOOTER //
// ./src/components/activity/Activity.js